import { render, staticRenderFns } from "./payitem.vue?vue&type=template&id=88abdfc6&scoped=true&"
import script from "./payitem.vue?vue&type=script&lang=js&"
export * from "./payitem.vue?vue&type=script&lang=js&"
import style0 from "./payitem.vue?vue&type=style&index=0&id=88abdfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abdfc6",
  null
  
)

export default component.exports